import { toast } from "react-toastify";
import { i18n } from "../translate/i18n";
import { getBackendUrl } from "../config";

const mapFriendlyBackendErrorKey = message => {
	const normalized = String(message || "").toLowerCase();

	if (normalized.includes("license expired")) {
		return "ERR_LICENSE_EXPIRED";
	}

	if (normalized.includes("license not found")) {
		return "ERR_LICENSE_NOT_FOUND";
	}

	if (normalized.includes("license binding mismatch")) {
		return "ERR_LICENSE_BINDING_MISMATCH";
	}

	return null;
};

const isLikelyMixedContentError = () => {
	try {
		const backendUrl = String(getBackendUrl() || "");
		return (
			window?.location?.protocol === "https:" &&
			backendUrl.toLowerCase().startsWith("http://")
		);
	} catch (error) {
		return false;
	}
};

const toastError = err => {
	const errorMsg = err.response?.data?.message || err.response?.data?.error;
	if (errorMsg) {
		const mappedKey = mapFriendlyBackendErrorKey(errorMsg);
		if (mappedKey && i18n.exists(`backendErrors.${mappedKey}`)) {
			toast.error(i18n.t(`backendErrors.${mappedKey}`), {
				toastId: mappedKey,
			});
		} else if (i18n.exists(`backendErrors.${errorMsg}`)) {
			toast.error(i18n.t(`backendErrors.${errorMsg}`), {
				toastId: errorMsg,
			});
		} else {
			toast.error(errorMsg, {
				toastId: errorMsg,
			});
		}
	} else {
		const fallbackKey = isLikelyMixedContentError()
			? "ERR_BACKEND_HTTPS_HTTP_MISMATCH"
			: "ERR_BACKEND_UNREACHABLE";

		if (i18n.exists(`backendErrors.${fallbackKey}`)) {
			toast.error(i18n.t(`backendErrors.${fallbackKey}`), {
				toastId: fallbackKey,
			});
		} else {
			toast.error("An error occurred!");
		}
	}
};

export default toastError;
